/* El menú de celular. Antes el hamburguesa era decoración: siete secciones
   inalcanzables justo donde está la mitad del tráfico.

   Y además, desde aquí se publica el ALTO REAL de la cabecera: es el archivo que
   cargan las doce páginas, así que es el único sitio desde donde la medida llega
   a todas. */

/* ── EL ALTO DE LA CABECERA SE MIDE, NO SE ESCRIBE ─────────────────────────
   🔴 `pagina.css` traía `section[id]{scroll-margin-top:78px}`, escrito cuando la
   cabecera medía 78. Medida hoy: **98 px**. Cada salto del menú aterrizaba 20 px
   por debajo de la cornisa —el título tapado— sin un solo error en consola. Y no
   es un número que se pueda arreglar a mano: la cabecera se CONDENSA al bajar,
   así que su alto cambia mientras se navega.

   Es el mismo patrón que ya usa `filtra.js` para la barra del catálogo; aquí
   sube al sitio entero. `filtra.js` sigue publicando su `--alto-barra`, y las
   dos medidas se suman en la hoja. */
(() => {
  const nav = document.querySelector('.nav');
  if (!nav) return;
  const mide = () => document.documentElement.style.setProperty(
    '--alto-nav', Math.round(nav.getBoundingClientRect().height) + 'px');
  mide();
  addEventListener('resize', mide);
  if ('ResizeObserver' in window) new ResizeObserver(mide).observe(nav);
})();

const abrir  = document.getElementById('abrir-menu');
const cerrar = document.getElementById('cerrar-menu');
const panel  = document.getElementById('panel-movil');
const tapa   = document.getElementById('tapa-menu');

if (abrir && panel && tapa) {

/* Quién abrió, para devolverle el foco al cerrar. Sin esto, cerrar el menú con
   teclado deja el foco al principio del documento y hay que volver a tabular
   por todo el encabezado. Es la misma regla de la bolsa. */
let quienAbrio = null;

const FOCABLES = 'a[href],button:not([disabled]),input,select,textarea,[tabindex]:not([tabindex="-1"])';

/* ── EL ORDEN DE ENTRADA SE NUMERA UNA VEZ ─────────────────────────────────
   El escalonado vive en la hoja (`--i`), pero el índice tiene que ponerlo
   alguien, y el HTML de las trece páginas no debería cargar con un número de
   coreografía en cada `<li>`. Se numera aquí, al arrancar, y se acabó: no hay
   trabajo por apertura.
   El lema del final entra DESPUÉS del último renglón — es el remate, no un
   renglón más. */
{
  /* 🔴 `:scope > nav > ul > li`, NO `querySelectorAll('li')`. Desde el 5-sep
     «Shop» lleva sus tres categorías en una lista ANIDADA: con el selector
     suelto, esos tres hijos entraban en la coreografía y se llevaban tres
     números del escalonado, así que los cuatro renglones de abajo entraban
     tarde y el lema del final llegaba con 90 ms de retraso extra. Sólo se
     numera el primer nivel, que es el que se ve al abrir. */
  const filas = [...panel.querySelectorAll('nav > ul > li')];
  filas.forEach((li, i) => li.style.setProperty('--i', i));
  const lema = panel.querySelector('.lema-panel');
  if (lema) lema.style.setProperty('--i', filas.length);
}

/* ── EL DESPLEGABLE DE «SHOP» ──────────────────────────────────────────────
   paco: «que sea un dropdown». El enlace sigue llevando a la tienda; esto sólo
   abre y cierra las categorías.
   🔴 EL ESTADO VIVE EN DOS SITIOS Y LOS DOS HACEN FALTA: `aria-expanded` en el
   botón —que es lo que anuncia un lector de pantalla— y `data-abierto` en la
   fila, que es de lo que cuelga el CSS. Un solo atributo no sirve para las dos
   cosas: el CSS no puede colgar del `aria-expanded` de un HERMANO posterior.
   Y al cerrar el cajón entero se pliega también esto: si mañana se vuelve a
   abrir el menú, empieza como empezó, no como lo dejó la visita anterior. */
{
  const fila = panel.querySelector('.con-sub-movil');
  const bt   = fila && fila.querySelector('.abre-sub');
  if (bt) {
    const pon = (si) => {
      bt.setAttribute('aria-expanded', String(si));
      fila.toggleAttribute('data-abierto', si);
    };
    bt.addEventListener('click', () =>
      pon(bt.getAttribute('aria-expanded') !== 'true'));
    window.__cierraSubMenu = () => pon(false);
  }
}

function mostrar(si){
  if (!si && window.__cierraSubMenu) window.__cierraSubMenu();
  // `hidden` se quita ANTES de animar: un elemento con display:none no transiciona.
  if (si){ panel.hidden = false; tapa.hidden = false; requestAnimationFrame(() => {
    panel.classList.add('abierto'); tapa.classList.add('abierta'); }); }
  else { panel.classList.remove('abierto'); tapa.classList.remove('abierta');
    setTimeout(() => { if (!panel.classList.contains('abierto')){
      panel.hidden = true; tapa.hidden = true; } }, 400); }
  abrir.setAttribute('aria-expanded', String(si));

  /* 🔴 SE TRABA EL FONDO COMO LO TRABA LA BOLSA, NO CON `overflow:hidden`.
     La regla vieja era `body.trabado{overflow:hidden}`: en celular funciona de
     casualidad —no hay barra de desplazamiento que quitar— pero deja el
     arrastre táctil de iOS suelto, y el día que este panel se vea en una
     pantalla con barra, el sitio entero brinca 15 px. `Bolsa.trabar` congela la
     posición y `scrollbar-gutter:stable` reserva el hueco. */
  document.body.classList.toggle('trabado', si);
  if (window.Bolsa && window.Bolsa.trabar) window.Bolsa.trabar(si);

  if (si){ quienAbrio = document.activeElement; panel.querySelector('a').focus(); }
  else if (quienAbrio && quienAbrio.isConnected) quienAbrio.focus();
}

abrir.addEventListener('click', () => mostrar(true));
if (cerrar) cerrar.addEventListener('click', () => mostrar(false));
tapa.addEventListener('click', () => mostrar(false));
panel.querySelectorAll('a').forEach(a => a.addEventListener('click', () => mostrar(false)));

addEventListener('keydown', e => {
  if (!panel.classList.contains('abierto')) return;
  if (e.key === 'Escape') { mostrar(false); return; }
  /* 🔴 EL FOCO SE QUEDA DENTRO. Con Tab se salía del panel y se seguía tabulando
     por la página de atrás, que está tapada por la cortina: el anillo de foco
     desaparecía de la vista y no había manera de saber dónde estaba. Mismo
     fallo que tenía la bolsa, mismo arreglo. */
  if (e.key !== 'Tab') return;
  const f = [...panel.querySelectorAll(FOCABLES)].filter(n => n.offsetParent !== null);
  if (!f.length) return;
  const primero = f[0], ultimo = f[f.length - 1];
  if (e.shiftKey && document.activeElement === primero){ e.preventDefault(); ultimo.focus(); }
  else if (!e.shiftKey && document.activeElement === ultimo){ e.preventDefault(); primero.focus(); }
});

}
